import { render } from "./Clubcard.vue?vue&type=template&id=2cfed2d4"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/Clubcard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2cfed2d4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2cfed2d4', __exports__)) {
    api.reload('2cfed2d4', __exports__)
  }
  
  module.hot.accept("./Clubcard.vue?vue&type=template&id=2cfed2d4", () => {
    api.rerender('2cfed2d4', render)
  })

}


export default __exports__